exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2WJbVIbQhdmSt0{text-align:center}._2IEA83FP2NlWEy{margin-left:12px}._2CMksetVqGSSpW{color:#172b4d;font-size:14px;font-weight:400;line-height:20px;font-weight:700;margin:0}", ""]);

// exports
exports.locals = {
	"banner": "_2WJbVIbQhdmSt0",
	"link": "_2IEA83FP2NlWEy",
	"text": "_2CMksetVqGSSpW"
};